export default function disableRestrictedForm() {
  document.querySelectorAll("form.disabled").forEach(form => {
    form.querySelectorAll("input, textarea, button, select").forEach(el => {
      el.disabled = true
    })
  })
}
